import { Helmet } from 'react-helmet-async'

const SITE_NAME = 'Salient Agrinutrition'
const SITE_URL  = 'https://salientagrinutrition.com'
const DEFAULT_IMAGE = `${SITE_URL}/og-default.jpg`

export default function SEOHead({
  title,
  description,
  path = '',
  image = DEFAULT_IMAGE,
  type = 'website',
  jsonLd = null,
}) {
  const fullTitle   = title ? `${title} | ${SITE_NAME}` : SITE_NAME
  const canonicalUrl = `${SITE_URL}${path}`
  const fullImage    = image.startsWith('http') ? image : `${SITE_URL}${image}`

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type"      content={type} />
      <meta property="og:title"     content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url"       content={canonicalUrl} />
      <meta property="og:image"     content={fullImage} />

      {/* Twitter Card */}
      <meta name="twitter:card"        content="summary_large_image" />
      <meta name="twitter:title"       content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image"       content={fullImage} />

      {/* Structured data */}
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  )
}
